import { TrackingQBusEvents } from '@otto-ec/tracking-bct';
import { logger } from '@otto-ec/global-resources/debug';

const log = logger('ft5.component-repository.emit-tracking-event');

export function emitTrackingEvent<TopicName extends keyof TrackingQBusEvents>(
    topicName: TopicName,
    ...trackingData: TrackingQBusEvents[TopicName]
): void {
    window.o_global.events<TrackingQBusEvents>().emit(topicName, ...trackingData);
    log.info('ft5 funk tracking sent event', topicName, ...trackingData);
}
